export interface ReviewFormData {
  activities: number[];
  comment: string;
  feelings: number[];
  rating: number; // 0 means no rating is selected
}

export const INITIAL_REVIEW_FORM_DATA: ReviewFormData = {
  activities: [],
  comment: '',
  feelings: [],
  rating: 0,
};

export const isReviewSubmittable = (data: ReviewFormData): boolean =>
  data.rating > 0;
